// Service Worker Registration Utility

let registration = null;
let updateAvailable = false;
let waitingWorker = null;
let updateCallbacks = [];

/**
 * Register the service worker
 */
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((reg) => {
          registration = reg;
          console.log('[Service Worker] Registered successfully:', reg.scope);

          // Check for updates immediately
          reg.update();

          // Check for updates every hour
          setInterval(() => {
            reg.update();
          }, 60 * 60 * 1000);

          // Listen for updates
          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {
                    // New service worker available
                    updateAvailable = true;
                    waitingWorker = newWorker;
                    notifyUpdateAvailable();
                  } else {
                    // First time installation
                    console.log('[Service Worker] Content cached for offline use.');
                  }
                }
              });
            }
          });

          // Listen for controller change (when new SW takes control)
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            window.location.reload();
          });
        })
        .catch((error) => {
          console.error('[Service Worker] Registration failed:', error);
        });
    });
  }
};

/**
 * Subscribe to update notifications
 */
export const onUpdateAvailable = (callback) => {
  updateCallbacks.push(callback);
  if (updateAvailable) {
    callback();
  }
};

/**
 * Unsubscribe from update notifications
 */
export const offUpdateAvailable = (callback) => {
  updateCallbacks = updateCallbacks.filter((cb) => cb !== callback);
};

/**
 * Notify all subscribers about available update
 */
const notifyUpdateAvailable = () => {
  updateCallbacks.forEach((callback) => {
    try {
      callback();
    } catch (error) {
      console.error('[Service Worker] Error in update callback:', error);
    }
  });
};

/**
 * Skip waiting and activate the new service worker
 */
export const skipWaiting = () => {
  if (waitingWorker) {
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    waitingWorker = null;
    updateAvailable = false;
  }
};

/**
 * Check if update is available
 */
export const isUpdateAvailable = () => {
  return updateAvailable;
};

/**
 * Unregister service worker (useful for development)
 */
export const unregister = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[Service Worker] Unregistration failed:', error);
      });
  }
};

